module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-note",
    class: {
      'note-editing': _vm.editing, 'disable-text': _vm.disableText
    },
    attrs: {
      "id": _vm.note.id,
      "x": _vm.notePosLeft,
      "y": _vm.notePosTop,
      "w": _vm.note.width,
      "h": _vm.note.height,
      "minw": 40,
      "minh": 40,
      "handles": ['br'],
      "active": _vm.editing,
      "parent": true,
      "draggable": !_vm.locked,
      "resizable": !_vm.locked,
      "drag-handle": ".drag"
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "resizestop": _vm.onResize,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [_c('md-dialog', {
    ref: "text-edit-dialog",
    attrs: {
      "md-open-from": ("#" + (_vm.note.id)),
      "md-close-to": ("#" + (_vm.note.id))
    }
  }, [_c('md-dialog-title', [_vm._v("Edit Note")]), _vm._v(" "), _c('md-dialog-content', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    staticClass: "note-input",
    attrs: {
      "placeholder": "Enter Text"
    },
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layer-picker-container"
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layerByID(_vm.note.layer),
      "layers": _vm.validLayers,
      "editable": !_vm.locked,
      "locked": _vm.locked
    },
    on: {
      "selectLayer": _vm.selectLayer
    }
  }), _vm._v(" "), _c('span', [_vm._v("Select Note Layer")])], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Done")])], 1)], 1), _vm._v(" "), _c('span', {
    ref: "note-text",
    staticClass: "note-text",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.noteText) + "\n        ")]), _vm._v(" "), (_vm.editing && !_vm.locked) ? _c('div', {
    staticClass: "button-container"
  }, [_c('span', {
    staticClass: "edit-button drag md-mini"
  }, [_c('md-icon', [_vm._v("zoom_out_map")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Move")])], 1), _vm._v(" "), _c('span', {
    staticClass: "edit-button md-mini",
    on: {
      "click": _vm.open
    }
  }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit")])], 1), _vm._v(" "), _c('span', {
    staticClass: "edit-button md-mini",
    on: {
      "click": _vm.remove
    }
  }, [_c('md-icon', [_vm._v("clear")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3c57c34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/notes/note.vue
// module id = 682
// module chunks = 2